import React from "react";
import PropTypes from "prop-types";
import styles from "./index.module.css";

import ActionButton from "../ActionButton";

const DownloadSuccess = ({ onOk, text }) => (
  <div className={styles.root}>
    <h1 className={styles.title}>Thank You</h1>
    <p className={styles.body}>
      {text ? (
        text
      ) : (
        <span>
          Your download will start in a few moments. Check your browser{"'"}s
          download folder.
        </span>
      )}
    </p>
    <div className={styles.button}>
      <ActionButton label="OK" onClick={onOk} />
    </div>
  </div>
);

DownloadSuccess.defaultProps = {
  email: "your address"
};

DownloadSuccess.propTypes = {
  // email: PropTypes.string,
  text: PropTypes.string,
  onOk: PropTypes.func
};

export default DownloadSuccess;



// WEBPACK FOOTER //
// ./src/components/DownloadSuccess/index.js